/* eslint-disable class-methods-use-this */
import Popup from './popup';

export default class PayForwardPopup extends Popup {
  createComponent() {
    return document.createElement(`au-${this.type}`);
  }

  setAttributes(payForwardPopup) {
    payForwardPopup.setAttribute('name', payForwardPopup._link.name);

    payForwardPopup.setAttribute('content', 'share-to-aw');

    payForwardPopup.setAttribute(
      'semantic-name',
      payForwardPopup._link.semanticName
    );
  }
}
